module.exports = __webpack_public_path__ + "img/selected3-min.57709d33.png";